import React from "react";
import PropTypes from "prop-types";
import Navbar from "./Navbar";
import Settings from "./Settings";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setUsageData } from "../../data/usage/actions";
import { Logo } from "cakemail-ui-components/lib/react";

export const Menu = (props) => {
	return (
		<div className="row">
			<div className="col-xs-12">
				<div id="header">
					<Logo className="logo" url={props.logo} />
					<Navbar />
					<Settings {...props} />
				</div>
			</div>

			{props.account != null && (
				<div
					className="accountInfo"
					style={{ display: "none", visibility: "hidden", opacity: 0 }}
					data-lineage-id={props.account.lineage}
					data-account-id={props.account.id}
					data-user-id={props.user && props.user.id}
				>
					&nbsp;
				</div>
			)}
		</div>
	);
};

Menu.propTypes = {
	account: PropTypes.object,
	user: PropTypes.object,
	logo: PropTypes.string,
};

Menu.defaultProps = {};

export default connect(
	(state) => {
		return {
			logo: state.brand?.images?.logo,
			account: state.global.account,
			user: state.global.user,
		};
	},
	(dispatch) =>
		bindActionCreators(
			{
				setUsageData,
			},
			dispatch
		)
)(Menu);
